function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: 2,
  transform: "translate(-499.000000, -376.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dialog",
  transform: "translate(197.000000, 207.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "home_ic"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(302.000000, 169.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "undraw_at_home_octe"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#E6E6E6",
  fillRule: "nonzero",
  cx: 85.4289137,
  cy: 226.137226,
  rx: 11.2766521,
  ry: 23.0089264
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.4702651,263.799124 C81.9538488,236.701487 86.4247932,209.701749 86.4704822,209.432405 L87.3489965,209.581214 C87.3035246,209.849256 82.8582497,236.707137 87.3492135,263.65292 L86.4702651,263.799124 Z",
  id: "Path",
  fill: "#3F3D56",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  transform: "translate(90.468553, 224.309679) rotate(-28.141600) translate(-90.468553, -224.309679) ",
  x: 84.6864479,
  y: 223.864082,
  width: 11.5642095,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  transform: "translate(79.705753, 227.043376) rotate(-61.842040) translate(-79.705753, -227.043376) ",
  x: 79.2601559,
  y: 221.261071,
  width: 1,
  height: 11.5646087
}), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  attributeType: "XML",
  type: "rotate",
  begin: "0s",
  values: "-0.6 71 323; 0.6 71 323; -0.6 71 323",
  dur: "5s",
  repeatCount: "indefinite",
  fill: "freeze"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  x: 294.37605,
  y: 100.307735,
  width: 18.4825275,
  height: 63.977984
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#3F3D56",
  fillRule: "nonzero",
  points: "325.064443 152.250177 280.11179 98.7720207 189.878639 99.5970569 135.141809 152.911679 136.247799 153.622783 135.852913 153.622783 135.852913 264.517878 324.943149 264.517878 324.943149 153.622783"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#1FA0FF",
  fillRule: "nonzero",
  points: "280.15868 98.8859524 224.000416 164.725701 224.000416 264.517878 324.943149 264.517878 324.943149 152.200962"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  x: 264.519649,
  y: 209.331436,
  width: 20.6151434,
  height: 18.2213991
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  x: 264.519649,
  y: 177.792186,
  width: 20.6151434,
  height: 17.9324388
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 264.519649,
  y: 209.331436,
  width: 20.6151434,
  height: 18.2213991
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 264.519649,
  y: 177.792186,
  width: 20.6151434,
  height: 17.9324388
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.000927,261.266302 C210.000927,261.266302 210.442866,252.006024 219.502663,253.082404",
  id: "Path",
  fill: "#E6E6E6",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#1FA0FF",
  fillRule: "nonzero",
  cx: 207.44104,
  cy: 247.919638,
  r: 4.5343625
}, /*#__PURE__*/React.createElement("animateTransform", {
  id: "anim1",
  attributeName: "transform",
  attributeType: "XML",
  type: "translate",
  begin: "0s",
  values: "2,0;-2,0;2,0",
  dur: "2s",
  repeatCount: "indefinite",
  fill: "freeze"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#E6E6E6",
  fillRule: "nonzero",
  x: 206.703232,
  y: 255.555234,
  width: 1.27994155,
  height: 8.95959857
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#1FA0FF",
  fillRule: "nonzero",
  cx: 58.3344654,
  cy: 190.652291,
  rx: 22.0558023,
  ry: 45.0027483
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.7911434,264.244698 C51.969348,211.31477 60.7021604,158.577608 60.7913643,158.051104 L61.6698786,158.199913 C61.5808956,158.725115 52.8737527,211.320424 61.6700956,264.09849 L60.7911434,264.244698 Z",
  id: "Path",
  fill: "#3F3D56",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  transform: "translate(68.191378, 187.077671) rotate(-28.141600) translate(-68.191378, -187.077671) ",
  x: 56.881986,
  y: 186.632074,
  width: 22.6187839,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  transform: "translate(47.140727, 192.424518) rotate(-61.842580) translate(-47.140727, -192.424518) ",
  x: 46.6951299,
  y: 181.115126,
  width: 1,
  height: 22.6187839
}), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  attributeType: "XML",
  type: "rotate",
  begin: "0s",
  values: "-0.5 71 323; 0.5 71 323; -0.5 71 323",
  dur: "4s",
  repeatCount: "indefinite",
  fill: "freeze"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#1FA0FF",
  fillRule: "nonzero",
  cx: 110.571894,
  cy: 163.566217,
  rx: 30.181626,
  ry: 61.582709
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.095717,264.244698 C102.028293,191.841021 113.973879,119.701689 114.095934,118.981552 L114.974448,119.13036 C114.852611,119.849192 102.932694,191.846675 114.974665,264.09849 L114.095717,264.244698 Z",
  id: "Path",
  fill: "#3F3D56",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  transform: "translate(124.060378, 158.674540) rotate(-28.141600) translate(-124.060378, -158.674540) ",
  x: 108.584408,
  y: 158.228943,
  width: 30.9519401,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  transform: "translate(95.254210, 165.991236) rotate(-61.843290) translate(-95.254210, -165.991236) ",
  x: 94.8086127,
  y: 150.515266,
  width: 1,
  height: 30.9519401
}), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  attributeType: "XML",
  type: "rotate",
  begin: "0s",
  values: "-0.3 71 323; 0.3 71 323; -0.3 71 323",
  dur: "3.5s",
  repeatCount: "indefinite",
  fill: "freeze"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  transform: "translate(185.000000, 263.304996) scale(1, -1) translate(-185.000000, -263.304996) ",
  x: 0,
  y: 262.825721,
  width: 370,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  x: 172.904525,
  y: 204.496499,
  width: 20.6151434,
  height: 18.2213991
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  x: 172.904525,
  y: 172.957249,
  width: 20.6151434,
  height: 17.9324388
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 172.904525,
  y: 204.496499,
  width: 20.6151434,
  height: 18.2213991
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  x: 172.904525,
  y: 172.957249,
  width: 20.6151434,
  height: 17.9324388
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(5, 18)",
  xmlns: "http://www.w3.org/2000/svg",
  d: "M195.369427,20.0476758 L186.255899,25.8140437 L191.787435,15.7799782 C190.221112,14.5340706 188.28302,13.8440091 186.279387,13.8188277 L186.132584,13.8188277 C185.499545,13.8302125 184.866752,13.7851511 184.241762,13.6841815 L181.153028,15.6336237 L182.474255,13.2334096 C180.284912,12.4698503 178.393934,11.0354582 177.071905,9.13548322 L171.546242,12.6479916 L175.057769,6.307914 C171.828103,2.44415483 167.470991,0.067357513 162.67347,0.067357513 C156.924666,0.067357513 151.804179,3.48034479 148.498176,8.79008657 C146.50768,12.0361555 142.916597,13.9604662 139.102786,13.8246819 L138.797436,13.8246819 C132.449675,13.8246819 127.305699,21.0019072 127.305699,29.8475741 C127.305699,38.6932409 132.449675,45.8704663 138.797436,45.8704663 C140.19143,45.8652809 141.563456,45.5238241 142.796349,44.8752556 C146.936192,42.7267714 152.373774,42.6857921 156.707398,44.6001091 C160.47068,46.2744052 164.770562,46.2744052 168.533845,44.6001091 C172.948971,42.6924058 177.977178,42.7885192 182.315707,44.8635473 C183.53966,45.500329 184.898805,45.8355645 186.279387,45.8411954 C192.627148,45.8411954 197.771124,38.6698242 197.771124,29.8183032 C197.803145,26.4123962 196.977362,23.0529279 195.369427,20.0476758 Z",
  id: "Path",
  fillOpacity: 0.4,
  fill: "#1FA0FF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  attributeType: "XML",
  type: "translate",
  begin: "0.2s",
  from: "5, 18",
  to: "-455 -35",
  dur: "50s",
  repeatCount: 1,
  restart: "never",
  fill: "freeze"
})), /*#__PURE__*/React.createElement("path", {
  transform: "translate(5, 18)",
  d: "M234.51659,33.7184179 L240.213518,37.3767597 L236.755977,31.0105958 C237.734755,30.2182554 238.946713,29.7793116 240.19978,29.7633284 L240.29137,29.7633284 C240.687128,29.7674039 241.082478,29.7363741 241.472887,29.6705948 L243.400867,30.9132255 L242.576553,29.3877572 C243.947601,28.8967535 245.129365,27.9778568 245.951662,26.7633953 L249.404624,28.9797292 L247.22477,24.9643628 C249.24434,22.5069215 251.964578,21 254.964166,21 C258.554513,21 261.755601,23.1653303 263.820966,26.5361979 C265.064158,28.5874212 267.297815,29.8066689 269.673598,29.7308716 L269.870518,29.7308716 C273.836386,29.7308716 277.046632,34.284093 277.046632,39.8991146 C277.046632,45.5141361 273.840965,50.0673575 269.870518,50.0673575 C268.997488,50.0649453 268.138011,49.8485874 267.365518,49.4367688 C264.631508,48.0868833 261.449554,48.0224499 258.664422,49.2605749 C256.312579,50.3240181 253.624912,50.3240181 251.273069,49.2605749 C248.513307,48.0487035 245.369542,48.1113144 242.658984,49.4321321 C241.895096,49.8345784 241.047153,50.0460303 240.186041,50.0488108 C236.220173,50.0488108 233.005181,45.4955894 233.005181,39.8805678 C232.994524,37.7311621 233.513985,35.6130416 234.51659,33.7184179 Z",
  id: "Path",
  fillOpacity: 0.4,
  fill: "#1FA0FF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  attributeType: "XML",
  type: "translate",
  begin: "0.4s",
  from: "5, 18",
  to: "-455 -35",
  dur: "45.5s",
  repeatCount: 1,
  restart: "never",
  fill: "freeze"
})), /*#__PURE__*/React.createElement("path", {
  transform: "translate(5, 18)",
  d: "M278.985447,71.0042482 L282.973297,73.5540016 L280.553018,69.1169783 C281.238163,68.564741 282.086533,68.2588105 282.96368,68.2476707 L283.027793,68.2476707 C283.304824,68.2505112 283.581569,68.2288844 283.854855,68.1830382 L285.204441,69.0491141 L284.627421,67.985909 C285.587155,67.6436943 286.41439,67.0032511 286.989998,66.1568083 L289.407071,67.7015258 L287.881173,64.9029371 C289.294872,63.190175 291.199039,62.1398964 293.29875,62.1398964 C295.811993,62.1398964 298.052755,63.649066 299.49851,65.9984586 C300.368744,67.428099 301.932305,68.2778777 303.595353,68.2250493 L303.733196,68.2250493 C306.509304,68.2250493 308.756477,71.3985067 308.756477,75.3120065 C308.756477,79.2255064 306.51251,82.3989637 303.733196,82.3989637 C303.122076,82.3972825 302.520442,82.2464876 301.979697,81.9594625 C300.06589,81.0186332 297.838522,80.9737251 295.888929,81.8366607 C294.24264,82.5778484 292.361272,82.5778484 290.714983,81.8366607 C288.783149,80.9920231 286.582514,81.0356609 284.685123,81.9562309 C284.150401,82.2367238 283.556841,82.3840993 282.954063,82.3860372 C280.177955,82.3860372 277.927461,79.2125799 277.927461,75.29908 C277.920001,73.8010094 278.283624,72.3247435 278.985447,71.0042482 Z",
  id: "Path",
  fillOpacity: 0.4,
  fill: "#1FA0FF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  attributeType: "XML",
  type: "translate",
  begin: "0.6s",
  from: "5, 18",
  to: "-455 -35",
  dur: "42.5s",
  repeatCount: 1,
  restart: "never",
  fill: "freeze"
}))))))));

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "370px",
    height: "265px",
    viewBox: "0 0 370 265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.bbc5029dfc5e77f023fc31543c8a6cfc.svg";
export { ForwardRef as ReactComponent };